import React, {useRef, useState, useEffect} from "react"

import PropTypes from "prop-types"

import { Drawer } from "@components/Page"
import { EditButton } from "@components/Button"
import { EMAIL_DRAWER_WIDTH } from "@components"
import { EmailTemplatePreview } from "@components/Text"

import TemplateUpdateDrawer from "./TemplateUpdateDrawer"


const TemplateDrawer = ({
  projectId = undefined,
  drawer,
  resetTemplate,
  getTemplateByKey,
  updatedTemplateByKey,
  canEditTemplates = true,
}) => {
  const templateUpdateDrawer = useRef({})

  const [ templateKey, setTemplateKey ] = useState()

  useEffect(() => {
    setTemplateKey()
  }, [ projectId ])

  const template = templateKey
    ? getTemplateByKey(templateKey) || {}
    : {}

  const onOpen = item =>
    setTemplateKey(item.key)

  const openTemplateUpdateDrawer = () =>
    templateUpdateDrawer.current.open(template)

  const {
    name: title = "",
    isEditable = true,
    html,
    subject,
    variables,
  } = template

  const extra = isEditable
    ? (
        <EditButton
          onClick={openTemplateUpdateDrawer}
        />
      )
    : null

  const drawerProps = {
    width: EMAIL_DRAWER_WIDTH,
    styles: { body: { padding: 0 } },
    title,
    extra,
    drawer,
    onOpen
  }

  return (
    <Drawer {...drawerProps}>
      <EmailTemplatePreview
        variables={variables}
        htmlTemplate={html}
        subjectTemplate={subject}
      />

      <TemplateUpdateDrawer
        drawer={templateUpdateDrawer}
        projectId={projectId}
        resetTemplate={resetTemplate}
        updatedTemplateByKey={updatedTemplateByKey}
        canEditTemplates={canEditTemplates}
      />
    </Drawer>
  )
}

TemplateDrawer.propTypes = {
  drawer: PropTypes.shape().isRequired,
  projectId: PropTypes.string,
  resetTemplate: PropTypes.func.isRequired,
  getTemplateByKey: PropTypes.func.isRequired,
  updatedTemplateByKey: PropTypes.func.isRequired,
  canEditTemplates: PropTypes.bool,
}

export default TemplateDrawer
